import { EMOTICON, regEmoticons } from '~/emojis';
import TOKEN from '../TOKEN';

const createEmoticon =
  (context) =>
  ({ 0: text, index }) => ({
    type: TOKEN.EMOTICON,
    text,
    emoji: EMOTICON[text] ?? EMOTICON[text.toLowerCase()] ?? EMOTICON[text.toUpperCase] ?? text,
    index,
  });

createEmoticon.regex = regEmoticons;

export default createEmoticon;
